// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__3krse","expandIcon":"AccordionButton_expandIcon__2723J","expanded":"AccordionButton_expanded__32HwD"};